import React from 'react';
import * as S from './style';

export type InputType = 'EMAIL';

export interface Props {
    inputName: string;
    inputType?: InputType;
    disabled?: boolean;
    isValid?: boolean;
    placeholder?: string;
    value?: string | number;
    defaultValue?: string | number;
    width?: number;
    type?: string;
    maxLength?: number;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onFocusOut?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

function Input({ inputName, isValid = true, ...props }: Props): React.ReactElement {
    return <S.Input name={inputName} isValid={isValid} {...props} autoComplete="off" />;
}

export default Input;
